import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Button from '../../../../../Button'
import { LOGIN_FORM_FIELD_HEIGHT } from '../../../Login.constants'

function ResendCodeButton({
  isLoading,
  onResendCode,
  onSuccess,
  ...restProps
}) {
  const { t } = useTranslation()

  const { setErrors } = useFormikContext()

  function handleResendCode() {
    onResendCode({ setErrors }).then(() => {
      onSuccess?.()
    })
  }

  return (
    <Button.Outlined
      {...restProps}
      height={LOGIN_FORM_FIELD_HEIGHT}
      isLoading={isLoading}
      text={t('Auth.SignInByPhoneVerifyCodeResendCodeBtnKey')}
      onClick={handleResendCode}
    />
  )
}

export default ResendCodeButton
